/**
 * @generated SignedSource<<7d127fccb39e43de5ab24a4fe1fded5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TrackedByItems_item$data = {
  readonly number: number;
  readonly repository: {
    readonly nameWithOwner: string;
  };
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "TrackedByItems_item";
};
export type TrackedByItems_item$key = {
  readonly " $data"?: TrackedByItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"TrackedByItems_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TrackedByItems_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "de9d8bc089b8136e4b343ef1e20af847";

export default node;
